/**
 * CalibrationPage - a calibration on its own page (/calibrations/:calId, or
 * /calibrations/new?productId=). The same workspace is shown on the mix design
 * page; this route keeps links and bookmarks working.
 */
import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import CalibrationWorkspace from '../components/calibration/CalibrationWorkspace';

const CalibrationPage: React.FC = () => {
  const { calId: routeId } = useParams<{ calId: string }>();
  const calId = routeId && routeId !== 'new' ? routeId : null;
  const [searchParams] = useSearchParams();
  const productId = searchParams.get('productId') || '';
  const navigate = useNavigate();
  const suffix = productId ? `?productId=${productId}` : '';

  return (
    <Box>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(productId ? `/products/${productId}` : '/products')}
        sx={{ mb: 1 }}
      >
        Back
      </Button>
      <CalibrationWorkspace
        key={calId || 'new'}
        calId={calId}
        productId={productId}
        onOpen={(id) => navigate(`/calibrations/${id}${suffix}`, { replace: !calId })}
        onDeleted={() => navigate(productId ? `/products/${productId}` : '/products')}
      />
    </Box>
  );
};

export default CalibrationPage;
